import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Event } from '../types';
import { publicApi } from '../services/api';

const EventView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (id) {
      loadEvent(id);
    }
  }, [id]);

  const loadEvent = async (eventId: string) => {
    try {
      const eventData = await publicApi.getEvent(eventId);
      setEvent(eventData);
    } catch (err) {
      setError('Event not found');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading event...</div>;
  }

  if (error) {
    return <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>{error}</div>;
  }

  if (!event) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Event not found</div>;
  }

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      {event.bannerUrl && (
        <img
          src={event.bannerUrl}
          alt="Event banner"
          style={{
            width: '100%',
            height: '200px',
            objectFit: 'cover',
            borderRadius: '8px',
            marginBottom: '20px'
          }}
        />
      )}

      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
        {event.imageUrl && (
          <img
            src={event.imageUrl}
            alt={event.title}
            style={{
              width: '150px',
              height: '150px',
              objectFit: 'cover',
              borderRadius: '8px'
            }}
          />
        )}
        <div style={{ flex: 1 }}>
          <h1 style={{ margin: '0 0 10px 0' }}>{event.title}</h1>
          <p style={{ fontSize: '18px', color: '#666', margin: '0 0 10px 0' }}>
            <strong>📍 {event.location}</strong>
          </p>
          <p style={{ color: '#888', margin: '0' }}>
            Created: {new Date(event.createdDate).toLocaleDateString()}
          </p>
        </div>
      </div>

      {event.description && (
        <div style={{ marginBottom: '20px' }}>
          <h3>About this event</h3>
          <p style={{ lineHeight: '1.6' }}>{event.description}</p>
        </div>
      )}

      {event.instructions && (
        <div style={{ marginBottom: '20px' }}>
          <h3>Instructions</h3>
          <p style={{ lineHeight: '1.6' }}>{event.instructions}</p>
        </div>
      )}

      <div style={{ marginBottom: '30px' }}>
        <h3>Guests ({event.guests.length})</h3>
        {event.guests.length === 0 ? (
          <p>No guests registered yet.</p>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', marginTop: '15px' }}>
            {event.guests.map(guest => (
              <div
                key={guest.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px 15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '25px',
                  border: '1px solid #dee2e6'
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#007bff',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '10px',
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}
                >
                  {guest.profileLetter}
                </div>
                <span style={{ fontSize: '16px' }}>{guest.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {event.faqs && event.faqs.length > 0 && (
        <div style={{ marginBottom: '30px' }}>
          <h3>Spørsmål som potensielt kan bli stilt</h3>
          <div style={{ marginTop: '15px' }}>
            {event.faqs
              .sort((a, b) => a.displayOrder - b.displayOrder)
              .map((faq, index) => (
                <div
                  key={faq.id}
                  style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6'
                  }}
                >
                  <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
                    {index + 1}. {faq.question}
                  </div>
                  <div style={{ color: '#666', lineHeight: '1.6' }}>
                    {faq.answer}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EventView;